'use client'

import { useTranslate } from '@repo/shared/hooks'
import { Col, Icon, Row, Typography } from '@repo/ui/components'
import { ButtonLink } from '@repo/shared/components'
import { useIsDesktop } from '@repo/ui/hooks'

export const TransferCTA = ({ origin }: { origin: 'layout' | 'container' }) => {
  const { t } = useTranslate()
  const isDesktop = useIsDesktop()
  return (
    <Col
      className={`${origin === 'layout' ? 'sticky top-0' : ''}  bg-neutral-surface-light sm:bg-transparent  px-xs py-xs md:px-0  justify-between`}
    >
      {isDesktop && (
        <Row className='w-fit'>
          <ButtonLink
            variant='transparent'
            size='md'
            color='neutral'
            href='/wallet'
            startIcon={<Icon name='ArrowRightLine' size='md' />}
          >
            {t('common_back')}
          </ButtonLink>
        </Row>
      )}
      <Row className='w-full justify-between'>
        {!isDesktop && (
          <ButtonLink
            variant='transparent'
            size='sm'
            color='neutral'
            href='/wallet'
            aria-label='Back to Wallet'
            startIcon={<Icon name='ArrowRightLine' size='sm' />}
          >
            {!isDesktop && (
              <Typography size='md' weight='bold'>
                {t('walletTransferPage_title')}
              </Typography>
            )}
          </ButtonLink>
        )}

        {isDesktop && (
          <Typography size='lg' weight='bold'>
            {t('walletTransferPage_title')}
          </Typography>
        )}
        <ButtonLink
          variant='transparent'
          size='xs'
          color='base'
          href='/history/balance/all?type=transfer'
          aria-label='History'
          startIcon={<Icon name='ClockHistoryCircleGhostLine' size='xs' />}
        >
          {isDesktop && t('walletTransferPage_history')}
        </ButtonLink>
      </Row>
    </Col>
  )
}
